// 院区列表
import axios from '@/library/modules/axios.js'
export function getHosAreaList(id) {
  return axios.service({
    url: `/apis/v1/tenant/customer/public/hospitals/${id}/hospital-areas/query`,
    method: 'post'
  })
}
// 院区配置详情
export function getHosAreaDetail(params) {
  return axios.service({
    url: `/apis/v1/tenant/customer/public/hospital-areas/settings`,
    method: 'get',
    params
  })
}
// 查询院区列表
export function getHAreaList(data) {
  return axios.service({
    url: `/apis/v1/tenant/customer/public/hospital-areas/query`,
    method: 'post',
    data
  })
}
// 获取院区位置
export function getHAreaListPosition(data) {
  return axios.service({
    url: `/apis/v1/tenant/customer/public/hospital-area/position`,
    method: 'post',
    data
  })
}
